import React, { useState } from "react";
import PropTypes from "prop-types";
import useMediaQueries from "../../hooks/use-media-queries";
import ShopNavigationMobile from "./ShopNavigationMobile";
import ShopNavigationItem from "./ShopNavigationItem";
import "./ShopNavigation.scss";

const ShopNavigation = ({ title, items, cutoutBackgroundColor }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const isDesktop = useMediaQueries("desktop");

  return (
    <section
      data-palette={cutoutBackgroundColor}
      className="ShopNavigation__section"
    >
      {isDesktop ? (
        <div
          className="ShopNavigation"
          data-palette="blueberry"
          data-cutout="bottom"
          data-cutout-style="wave"
        >
          <div className="ShopNavigation__container container-guttered">
            <div className="ShopNavigation__menu">
              <h1 className="SectionHeading__heading">{title}</h1>
              <ul className="ShopNavigation__primary-list">
                {items?.map((item, index) => {
                  return (
                    <ShopNavigationItem
                      {...item}
                      key={item.title}
                      active={activeIndex === index}
                      onMouseOver={() => setActiveIndex(index)}
                      columns={item.document.body.map(({ id, items }) => ({
                        id,
                        items,
                      }))}
                    />
                  );
                })}
              </ul>
            </div>
            {items[activeIndex] && (
              <img
                className="ShopNavigation__image"
                src={items[activeIndex].image.url}
                alt={items[activeIndex].image.alt}
              />
            )}
          </div>
        </div>
      ) : (
        <ShopNavigationMobile title={title} items={items} />
      )}
    </section>
  );
};

ShopNavigation.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
      }),
      document: ShopNavigationItem.propTypes.columns,
    })
  ),
  cutoutBackgroundColor: PropTypes.string,
};

export default ShopNavigation;
